import React from "react";
import moment from "moment";

const ACCENT = "#161616";
const ACCENT_LIGHT = "#f5f5f5";
const ACCENT_HOVER = "#e5e5e5";

const OldMinimalTimeSlots = ({
  state,
  setState,
  showServiceDropdown,
  serviceError,
  setServiceError,
  timeSlots,
  isMobile,
}) => {
  const getSlotStyle = (isSelected, isAvailable = true) => ({
    padding: isMobile ? "14px 8px" : "12px",
    borderRadius: "12px",
    fontSize: isMobile ? "13px" : "12px",
    fontWeight: "600",
    cursor: isAvailable ? "pointer" : "not-allowed",
    textAlign: "center",
    background: !isAvailable
      ? "#e2e8f0"
      : isSelected
      ? ACCENT
      : ACCENT_LIGHT,
    color: !isAvailable
      ? "#718096"
      : isSelected
      ? "white"
      : ACCENT,
    border: "none",
    transition: "all 0.2s ease",
    lineHeight: "1.4",
    opacity: !isAvailable ? 0.6 : 1,
  });

  const handleMouseEnter = (e, isSelected, isAvailable = true) => {
    if (isAvailable && !isSelected)
      e.currentTarget.style.background = ACCENT_HOVER;
  };

  const handleMouseLeave = (e, isSelected, isAvailable = true) => {
    if (isAvailable && !isSelected)
      e.currentTarget.style.background = ACCENT_LIGHT;
  };

  return (
    <div
      style={{
        background: "white",
        borderRadius: "14px",
        border: "1px solid #e5e5e5",
        padding: isMobile ? "14px" : "18px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
        height: "100%",
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "14px",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        <h6
          style={{
            fontSize: "14px",
            fontWeight: "700",
            color: "#161616",
            margin: 0,
          }}
        >
          Select time
        </h6>

        {showServiceDropdown && (
          <div style={{ flex: "1", minWidth: "140px" }}>
            <select
              className={`form-control ${serviceError ? "border-danger" : ""}`}
              value={state.serviceId ?? ""}
              style={{ borderColor: serviceError ? "red" : "", fontSize: 16 }}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                  setState((prev) => ({
                    ...prev,
                    serviceId: null,
                    selectedService: null,
                  }));
                  return;
                }
                const serviceId = Number(value);
                const selectedServiceObj = state.serviceList.find(
                  (s) => s.id === serviceId
                );
                setState((prev) => ({
                  ...prev,
                  serviceId,
                  selectedService: serviceId,
                  selectedServiceObj,
                  type: "demo",
                }));
                setServiceError(false);
              }}
            >
              <option value="">Select a service</option>
              {state.serviceList?.map((service) => (
                <option key={service.id} value={service.id}>
                  {service.serviceName}
                </option>
              ))}
            </select>
            {serviceError && (
              <p className="text-danger mt-1" style={{ fontSize: "11px" }}>
                Please select a service
              </p>
            )}
          </div>
        )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
          gap: isMobile ? "8px" : "10px",
          maxHeight: isMobile ? "none" : "320px",
          overflowY: isMobile ? "visible" : "auto",
        }}
      >
        {state.appointmentValue === "Group Package" ? (
          <>
            {timeSlots.length > 0 ? (
              timeSlots.map((item, i) => {
                const isSelected = i === state.slotActiveIndex;
                return (
                  <div
                    key={i}
                    onClick={() =>
                      setState((previous) => ({
                        ...previous,
                        slotActiveIndex: i,
                        selectedSlot: item,
                      }))
                    }
                    style={getSlotStyle(isSelected)}
                    onMouseEnter={(e) => handleMouseEnter(e, isSelected)}
                    onMouseLeave={(e) => handleMouseLeave(e, isSelected)}
                  >
                    {moment(item.from, ["h:mm a"]).format("LT")} -{" "}
                    {moment(item.to, ["h:mm a"]).format("LT")}
                  </div>
                );
              })
            ) : (
              <p
                style={{
                  fontSize: "12px",
                  color: "#718096",
                  gridColumn: "1/-1",
                  textAlign: "center",
                }}
              >
                No group package slots available
              </p>
            )}
          </>
        ) : (
          <>
            {state.availableSlot.length > 0 ? (
              state.availableSlot.map((item, i) => {
                const isSelected = i === state.slotActiveIndex;
                const isAvailable = item.slotAvailable;
                return (
                  <div
                    key={i}
                    onClick={() => {
                      if (isAvailable) {
                        setState((previous) => ({
                          ...previous,
                          slotActiveIndex: i,
                          selectedSlot: item,
                        }));
                      }
                    }}
                    style={getSlotStyle(isSelected, isAvailable)}
                    onMouseEnter={(e) =>
                      handleMouseEnter(e, isSelected, isAvailable)
                    }
                    onMouseLeave={(e) =>
                      handleMouseLeave(e, isSelected, isAvailable)
                    }
                  >
                    {moment(`2024-01-01T${item.from}:00`)
                      .locale("en")
                      .format("LT")}{" "}
                    -{" "}
                    {moment(`2024-01-01T${item.to}:00`)
                      .locale("en")
                      .format("LT")}
                  </div>
                );
              })
            ) : (
              <p
                style={{
                  fontSize: "12px",
                  color: "#718096",
                  gridColumn: "1/-1",
                  textAlign: "center",
                }}
              >
                No slots available!
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default OldMinimalTimeSlots;